/* unplugin-vue-components disabled */import script from "./ConflictOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./ConflictOverview.vue?vue&type=script&setup=true&lang=js"

import "./ConflictOverview.vue?vue&type=style&index=0&id=6e629c08&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e629c08"]])

export default __exports__